/* eslint-disable */
<template>
  <div>
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Device Management">Device Management</a><span
          class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Device</li>
    </vs-breadcrumb>
    <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Device Management</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Sensor</h5></b-breadcrumb-item>
    </b-breadcrumb> -->

    <vs-row vs-w="12" v-if="username == 'frasers.kho' ||
      username == 'frasers.ban' ||
      username == 'frasers.roj'
      ">
      <vs-card class="roundedCard text-center">
        <div class="mt-2" slot="header">
          <vs-row id="center">
            <h3 class="headerText text-left">Device Map</h3>
            <vs-spacer />
            <!-- <vs-tooltip text="Print" position="top" >
            <vs-button radius   color="#333f50" type="line"   icon="print"></vs-button></vs-tooltip>&nbsp;&nbsp;
            <vs-tooltip text="Download a PDF" position="top" >
              <vs-button radius  color="#333f50" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>&nbsp;&nbsp;
              <vs-tooltip text="Export" position="top" >
                <vs-button radius  color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>&nbsp;&nbsp;&nbsp;&nbsp; -->
          </vs-row>
        </div>
        <vs-row>
          <vs-col>
            <h4 v-if="network == 'All Network'">No selected location</h4>
            <h4 v-else>{{ network }}</h4>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col v-if="network == 'Endeavor'">
            <img class="imgMapFreacer" src="@/assets/images/frasers/Moon and Stairs Mystical Logo Template (4).png"
              width="50%" />
          </vs-col>
          <vs-col v-if="network == 'Kendall'">
            <img class="imgMapFreacer pt-4" src="@/assets/images/Freacer/undraw_product_iteration_kjok.png" width="50%" />
          </vs-col>
          <vs-col v-if="network == 'Rojana'">
            <img class="imgMapFreacer pt-4" src="@/assets/images/frasers/mapbangplee.png" width="50%" />
          </vs-col>
          <vs-col v-if="network == 'JasperW3 Warehouse'">
            <img class="imgMapFreacer pt-4" src="@/assets/images/frasers/mapJasper.png" width="50%" />
          </vs-col>
        </vs-row>
      </vs-card>
    </vs-row>
    <vs-row>
      <vs-card style="border-radius: 20px">
        <div class="mt-2">
          <vs-row id="center">
            <h3 class="headerText">Device</h3>
            <vs-spacer />
            <btnPrint :dataList="sensorlist" :headerName="'Sensor'" :header="header" />
            <btnPDF :dataList="sensorlist" :headerName="'Sensor'" :header="header" />
            <btnExportXLSX :dataList="sensorlist" :headerName="'Sensor'" :header="header" />
            <vs-tooltip text="Add New Device" position="top">
              <h6>
                <vs-button color="success" style="border-radius: 20px" size="sm" icon="add" v-b-modal.addsensor
                  type="filled">Add Device</vs-button>
              </h6>
            </vs-tooltip>
          </vs-row>
          <div v-if="username == 'frasers.kho'">
            <vs-dropdown>
              <h6 class="a-icon" href.prevent>
                Filters :
                {{ network }}
                <vs-icon class icon="expand_more" size="12px"></vs-icon>
              </h6>
              <vs-dropdown-menu>
                <vs-dropdown-item v-for="item in nwlist" :key="item.id" @click="actionchange2(item.id, item.name)">
                  {{ item.name }}</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <div v-else>
            <div class="mt-3 ml-2 filterContentHeader">
              <span class="mr-2">Filter by :</span>
              <vs-select placeholder="Select filter" multiple class="fontSizeData" v-model="searchHeader">
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in headerFilter" />
              </vs-select>
            </div>
            <vs-row>
              <div class="mt-2 fontSizeData" v-for="header in searchHeader" :key="header">
                <div v-if="header == 'Name'">
                  <div class="textfill textSuccess"><span>Name</span></div>
                  <div class="contentitem">
                    <vs-input class="inputx" placeholder="Search Name" v-model="selectFilterName" />
                    <vs-icon class="clearIcon" size="0.9rem" color="light" @click="remove(header)" icon="close"></vs-icon>
                  </div>
                </div>
                <div v-if="header == 'Serial Number'">
                  <div class="textfill textSuccess">
                    <span>Serial Number</span>
                  </div>
                  <div class="contentitem">
                    <vs-select placeholder="Select Serial Number" v-model="selectFilterSerialNumber">
                      <vs-select-item :key="index" :value="item" :text="item"
                        v-for="(item, index) in filterSerialNumber" />
                    </vs-select>
                    <vs-icon class="clearIcon" size="0.9rem" color="light" @click="remove(header)" icon="clear"></vs-icon>
                  </div>
                </div>
                <div v-if="header == 'Type'">
                  <div class="textfill textSuccess"><span>Type</span></div>
                  <div class="contentitem">
                    <vs-select placeholder="Select Type" v-model="selectFilterType">
                      <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in filterType" />
                    </vs-select>
                    <vs-icon class="clearIcon" size="0.9rem" color="light" @click="remove(header)" icon="clear"></vs-icon>
                  </div>
                </div>
                <div v-if="header == 'Network'">
                  <div class="textfill textSuccess"><span>Network</span></div>
                  <div class="contentitem">
                    <vs-select placeholder="Select Network" v-model="selectFilterNetwork">
                      <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in filterNetwork" />
                    </vs-select>
                    <vs-icon class="clearIcon" size="0.9rem" color="light" @click="remove(header)" icon="clear"></vs-icon>
                  </div>
                </div>
                <div v-if="header == 'Status'">
                  <div class="textfill textSuccess">
                    <span>Device Status</span>
                  </div>
                  <div class="contentitem">
                    <vs-select placeholder="Select Type" v-model="selectFilterActive">
                      <vs-select-item :key="index" :value="item.value" :text="item.text"
                        v-for="(item, index) in filterActive" />
                    </vs-select>
                    <vs-icon class="clearIcon" size="0.9rem" color="light" @click="remove(header)" icon="clear"></vs-icon>
                  </div>
                </div>
              </div>
            </vs-row>
          </div>
          <!-- <vs-row class="mt-4 mb-1">
          <vs-col
            style="padding-left: unset"
            vs-type="flex"
            vs-align="center"
            vs-lg="6"
            vs-sm="6"
            vs-xs="12"
          >
            <h6>Filters :</h6>
            <v-select
              style="min-width: 300px"
              class="ml-1"
              multiple
              v-model="selectFilter"
              :options="header"
            />
            <vs-button
              color="success"
              class="ml-1"
              @click="inputfilter2()"
              style="border-radius: 10rem; padding: 5px 15px"
              type="filled"
              >Search</vs-button
            >
            <vs-icon
              class="ml-2"
              icon="search"
              id="btns"
              @click="inputfilter2()"
              size="20px"
              color="dark"
            ></vs-icon>
          </vs-col>
        </vs-row>
        <vs-row
          id="center"
          class="mb-2"
          style="display: flex; align-items: center"
          :key="index"
          v-for="(item, index) in selectFilter"
        >
          <vs-icon
            icon="delete"
            id="btns"
            @click="removeItem(item, index, filtervalue)"
            size="18px"
            color="danger"
          ></vs-icon>
          <span class="mr-2 ml-1">{{ item }} :</span>
          <input
            class="inputx w3-input"
            style="width: 260px"
            @keydown.enter="inputfilter2()"
            v-model="filtervalue[index]"
          />
          </vs-row> -->
          <b-modal id="addsensor" :no-close-on-backdrop="false" hide-header-close centered hide-footer size="lg">
            <template #modal-title>
              <h4 class="textSuccess">Add New Device</h4>
            </template>
            <div>
              <AddDevice />
            </div>
          </b-modal>
        </div>
        <Table :header="header" :data="filteredList" :filter="actionchange" :filterlist="nwlist" :viewfunc="link2"
          :filtername="network" :deleteurl="'sensordel'" :idList="idList" />
      </vs-card>
    </vs-row>
  </div>
</template>

<script>
import btnPrint from "../Page/Button/btnPrint.vue";
import btnPDF from "../Page/Button/btnPDF.vue";
import btnExportXLSX from "../Page/Button/btnExportXLSX.vue";
import Table from "../material/Table.vue";
import moment from "moment";
import AddDevice from "../Page/Subpage/AddDevice.vue";
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  name: "Sensor",

  data: () => ({
    nwlist: [],
    filtervalue: [],
    items: [
      { name: "Peter", value: "" },
      { name: "Kitty", value: "" },
    ],
    i: "",
    sensorlist: [],
    selectFilter: [],
    options1: [
      { text: "Name", value: "Name" },
      { text: "Serial Number", value: "Serial Number" },
      { text: "Type", value: "Type" },
      { text: "Network", value: "Network" },
      { text: "Location", value: "Location" },
      { text: "Active Status", value: "Active Status" },
    ],
    d: "",
    network: "",
    role: "",
    a: [],
    filter_input: [
      {
        name: "",
        serial_id: "",
        type: "",
        network: "",
        location: "",
        active_status: "",
        signal: "",
        battery: "",
      },
    ],
    filter_list: [],
    primeTable: "",
    finds: [],
    counter: 0,
    dataBody: [],
    dataExport: [],
    idList: [],
    header: [
      "Name",
      "Serial Number",
      "Type",
      "Network",
      "Location",
      "Active Status",
      "Signal",
      "Battery",
    ],
    headerFilter: ["Name", "Serial Number", "Type", "Network", "Status"],
    searchHeader: "",
    searchItem: [],
    selectFilterName: "",
    filterType: [],
    filterItem: [],
    selectFilterType: "",
    filterType: [],
    filterNetwork: [],
    selectFilterNetwork: "",
    filterLocation: [],
    filterSerialNumber: [],
    selectFilterSerialNumber: "",
    selectFilterActive: null,
    filterSignal: "",
    filterActive: [
      { text: "Active", value: 1 },
      { text: "Inactive", value: 0 },
      { text: "Warning", value: 2 },
    ],
    username: "",
  }),
  components: {
    Table,
    AddDevice,
    btnPrint,
    btnPDF,
    btnExportXLSX,
  },
  methods: {
    remove(item) {
      this.searchHeader.splice(this.searchHeader.indexOf(item), 1);
      switch (item) {
        case "Name":
          this.selectFilterName = "";
          break;
        case "Type":
          this.selectFilterType = "";
          break;
        case "Serial Number":
          this.selectFilterSerialNumber = "";
          break;
        case "Network":
          this.selectFilterNetwork = "";
          break;
        case "Location":
          this.selectFilterLocation = "";
          break;
        case "Status":
          this.selectFilterActive = null;
          break;
        default:
        // console.log("Try looking up for a hint.");
      }
    },
    // export xlsx
    onExport() {
      this.sensorlist.forEach((element) => {
        this.dataExport.push({
          name: element.name,
          serial_id: element.serial_id,
          type: element.type,
          network: element.network,
          location: element.location,
          active: element.active,
          signal: "100",
          bat: "100",
        });
      });
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "exportSensor.xlsx");
      this.dataExport = [];
    },
    inputfilter2() {
      function addfilter(item, filtervalue, filter_input) {
        if (item == "Name") {
          filter_input[0].name = filtervalue;
        } else if (item == "Serial Number") {
          // this.filter_input[0]['serial_id'] = filtervalue
          filter_input[0].serial_id = filtervalue;
        } else if (item == "Type") {
          filter_input[0].type = filtervalue;
        } else if (item == "Network") {
          filter_input[0].network = filtervalue;
        } else if (item == "Location") {
          filter_input[0].location = filtervalue;
        } else if (item == "Active Status") {
          filter_input[0].active_status = filtervalue;
        } else if (item == "Signal") {
          filter_input[0].signal = filtervalue;
        } else if (item == "Battery") {
          filter_input[0].battery = filtervalue;
        }
      }
      // // console.log(this.filtervalue)
      for (let index in this.selectFilter) {
        var item = this.selectFilter[index];
        var filtervalue = this.filtervalue[index];
        addfilter(item, filtervalue, this.filter_input);
      }
      var body = this.filter_input[0];
      this.filter_list = [];
      this.$API
        .post("sensorfilter/" + this.$session.get("username"), body)
        .then((result) => {
          if (result) {
            // // console.log(result.status)
            result.data.forEach((element) => {
              this.filter_list.push({
                name: element.name,
                serial_id: element.serial_id,
                type: element.type,
                network: element.network,
                location: element.islocated || "Unavailable",
                active: element.active,
                signal: "100",
                bat: "100",
              });
            });
            if (this.counter == 0) {
              this.counter += 1;
              this.sensorlist = this.filter_list;
            } else {
              this.sensorlist = this.filter_list;
              this.counter += 1;
            }
            // // console.log(result.data)
          }
        })
        .catch((err) => {
          if (err.response.status == 500) {
            this.sensorlist = [];
          }
        });
    },
    removeItem(item, index, filtervalue) {
      var count = 0;
      //Delete Filter
      // // console.log(this.selectFilter)
      // // console.log(item)
      // // console.log(index)
      this.$delete(this.selectFilter, index);
      // Delete value of index from filter
      if (index > -1) {
        filtervalue.splice(index, 1);
      }
      // // console.log(this.filtervalue)
      function deletefilter(item, filter_input) {
        if (item == "Name") {
          filter_input[0].name = "";
        } else if (item == "Type") {
          filter_input[0].type = "";
        } else if (item == "Serial Number") {
          filter_input[0].serial_id = "";
        } else if (item == "Network") {
          filter_input[0].network = "";
        } else if (item == "Location") {
          filter_input[0].location = "";
        } else if (item == "Active Status") {
          filter_input[0].active_status = "";
        } else if (item == "Signal") {
          filter_input[0].signal = "";
        } else if (item == "Battery") {
          filter_input[0].battery = "";
        }
      }
      deletefilter(item, this.filter_input);
      var filter_data = this.filter_input[0];

      //Check filterinput data
      for (let i in filter_data) {
        if (filter_data[i].length != 0) {
          count += 1;
        }
      }
      //When delete filter
      if (count == 0 && filtervalue.length == 0) {
        this.sensorlist = this.primeTable;
        this.counter = 0;
        // // console.log("case1")
      } else {
        // // console.log("case2")
        var body = this.filter_input[0];
        this.filter_list = [];
        this.$API
          .post("sensorfilter/" + this.$session.get("username"), body)
          .then((result) => {
            if (result) {
              result.data.forEach((element) => {
                this.filter_list.push({
                  name: element.name,
                  serial_id: element.serial_id,
                  type: element.type,
                  network: element.network,
                  location: element.islocated || "Unavailable",
                  active: element.active,
                  signal: "100",
                  bat: "100",
                });
              });
              this.sensorlist = this.filter_list;
            }
          })
          .catch((err) => {
            // // console.log(err)
          });
      }
    },
    inputfilter(item, filtervalue, filterarray) {
      this.filtervalue;
      function addfilter(filtervalue, filter_input) {
        if (item == "Name") {
          filter_input[0].name = filtervalue;
        } else if (item == "Serial Number") {
          // this.filter_input[0]['serial_id'] = filtervalue
          filter_input[0].serial_id = filtervalue;
        } else if (item == "Type") {
          filter_input[0].type = filtervalue;
        } else if (item == "Network") {
          filter_input[0].network = filtervalue;
        } else if (item == "Location") {
          filter_input[0].location = filtervalue;
        } else if (item == "Active Status") {
          filter_input[0].active_status = filtervalue;
        } else if (item == "Signal") {
          filter_input[0].signal = filtervalue;
        } else if (item == "Battery") {
          filter_input[0].battery = filtervalue;
        }
      }
      addfilter(filtervalue, this.filter_input);
      var body = this.filter_input[0];
      this.filter_list = [];
      this.$API
        .post("sensorfilter/" + this.$session.get("username"), body, {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            "Access-Control-Allow-Origin": "*",
          },
          username: "admin",
          password: "admin",
          role: this.checkbox,
        })
        .then((result) => {
          // // console.log(result)
          if (result) {
            result.data.forEach((element) => {
              this.filter_list.push({
                name: element.name,
                serial_id: element.serial_id,
                type: element.type,
                network: element.network,
                location: element.islocated || "Unavailable",
                active: element.active,
                signal: "100",
                bat: "100",
              });
            });
            if (this.counter == 0) {
              this.primeTable = this.sensorlist;
              this.counter += 1;
              this.sensorlist = this.filter_list;
            } else {
              this.sensorlist = this.filter_list;
              this.counter += 1;
            }
            // // console.log(result.data)
          }
        })
        .catch((err) => {
          // // console.log(err)
        });
    },

    async actionchange2(id, name) {
      this.sensorlist = [];
      this.network = name;
      // console.log(name)
      try {
        if (name == "All Network") {
          await this.$API.get("sensors/user").then((result) => {
            result.data.forEach((element) => {
              this.sensorlist.push({
                name: element.name,
                serial_id: element.serial_id,
                type: element.type,
                network: element.network,
                location: element.islocated || "Unavailable",
                active: element.active,
                signal: "100",
                battery: "100",
              });
            });
          });
        } else {
          // console.log('else case')
          await this.$API.get("sensor/user/network/" + id).then((result) => {
            result.data.forEach((element) => {
              this.sensorlist.push({
                name: element.name,
                serial_id: element.serial_id,
                type: element.type,
                network: element.network,
                location: element.islocated || "Unavailable",
                active: element.active,
                signal: "100",
                battery: "100",
              });
            });
          });
        }
      } catch (err) {
        // console.log(err)
      }
      // eslint-disable-next-line no-console
      // console.log(this.sensorlist);
    },

    async actionchange(item) {
      var id = item.id;
      var name = item.name;
      this.ismounted = false;
      // // console.log(name)
      this.network = name;
      this.selectedFilter = name;
      this.sensorlist = [];
      if (name == "All Network") {
        await this.$API.get("sensors/user").then((result) => {
          // this.sensorlist = result.data
          // console.log(result.data)
          result.data.forEach((element) => {
            this.idList.push({
              name: element.name,
              serial_id: element.serial_id,
              id: element.id,
            });
            // // // console.log(element)
            if (element.lora)
              this.sensorlist.push({
                name: element.name,
                serial_id: element.serial_id,
                type: element.type,
                network: element.network,
                location: element.islocated || "Unavailable",
                active: element.active,
                signal: "100",
                bat: "100",
                lora: element.lora,
              });
            else
              this.sensorlist.push({
                name: element.name,
                serial_id: element.serial_id,
                gatewayid: element.gatewayid,
                type: element.type,
                network: element.network,
                location: element.islocated || "Unavailable",
                active: element.active,
                signal: "100",
                bat: "100",
                lora: element.lora,
              });
          });
          // // console.log(this.sensorlist)
          this.primeTable = this.sensorlist;

          this.sensorlist.forEach((element) => {
            this.filterType.push(element.type);
            this.filterNetwork.push(element.network);
            this.filterLocation.push(element.location);
            this.filterSerialNumber.push(element.serial_id);
            // this.filterActive.push(element.active);
          });

          // console.log(this.filterType);
          this.filterType = new Set(this.filterType);
          this.filterNetwork = new Set(this.filterNetwork);
          this.filterLocation = new Set(this.filterLocation);
          this.filterSerialNumber = new Set(this.filterSerialNumber);
          // this.filterActive = new Set(this.filterActive);
        });
      } else {
        await this.$API.get("sensor/user/network/" + id).then((result) => {
          result.data.forEach((element) => {
            this.sensorlist.push({
              name: element.name,
              serial_id: element.serial_id,
              type: element.type,
              network: element.network,
              location: element.islocated || "Unavailable",
              active: element.active,
              signal: "100",
              bat: "100",
            });
          });
        });
      }
      // eslint-disable-next-line no-console
      // // console.log(this.sensorlist)
    },
    link() {
      this.$router.push({
        name: "AddDevice",
        params: {
          nwname: this.name,
          nwid: this.id,
        },
      });
    },
    link2(item) {
      // this.$session.set('nwname',this.network)
      this.$session.set("nwname", item.network);
      this.$session.set("statussensor", item.active);
      this.$session.set("nwid", item.nwid);
      this.$session.set("sensorname", item.name);
      this.$session.set("sensorid", item.serial_id);
      this.$session.set("gatewayid", item.gatewayid);
      this.$session.set("type", item.type);
      this.$session.set("lora", item.lora);
      this.$session.set("location", item.location);
      this.$session.set("idsensor", this.findID(item));
      // // console.log(this.network,item)
      this.$router.push({
        name: "SensorDashboard",
        params: {
          nwname: this.network,
          nwid: item.nwid,
          sensorid: item.serial_id,
          gatewayid: item.gatewayid,
          type: item.type,
        },
      });
    },
    findID(item) {
      this.idList.forEach((element) => {
        if (element.name == item.name && element.serial_id == item.serial_id) {
          // console.log(element.id);
          return element.id;
        }
      });
    },
    filterByStatus(device, status) {
      if (status != null) {
        console.log(device.active, status)
        return device.active == status
      }
      return true
    }
  },
  async created() {
    this.$vs.loading.close();
    this.username = this.$session.get("username");
    this.admin = this.$session.get("admin");
    this.role = this.$session.get("role");
    await this.$API.get("network/user").then((result) => {
      this.nwlist = result.data;
      this.nwlist.forEach((element) => {
        if (element.name == "KhonKaen Warehouse") {
          element.value = "KhonKaen Warehouse";
          element.name = "Kendall";
        } else if (element.name == "Rojana Warehouse") {
          element.value = "Rojana Warehouse";
          element.name = "Endeavor";
        } else if (element.name == "Bangplee Warehouse") {
          element.value = "Bangplee Warehouse";
          element.name = "Unicorn";
        }
      });
      this.nwlist.unshift({ id: 0, name: "All Network", value: "All Network" });
      this.network = result.data[0].name;
      console.log(this.nwlist);
    });
    await this.$API.get("sensors/user").then((result) => {
      // this.sensorlist = result.data
      // console.log(result.data)
      let devices = null
      if (this.admin === "ajinomotodemo") {
        switch (this.username) {
          case 'ajtnk-sp1':
            devices = result.data.filter((val) => val.serial_id.startsWith('SP1'));
            break;
          case 'ajtnk-sp2':
            devices = result.data.filter((val) => val.serial_id.startsWith('SP2'));
            break;
          case 'ajtnk-sp3':
            devices = result.data.filter((val) => val.serial_id.startsWith('SP3'));
            break;
          case 'ajtnk-jp':
            devices = result.data.filter((val) => val.serial_id.startsWith('JP'));
            break;
          case 'ajtnk-ex':
            devices = result.data.filter((val) => val.serial_id.startsWith('MN-MDB_EX'));
            break;
          case 'ajtnk-ic':
            devices = result.data.filter((val) => val.serial_id.startsWith('SP1-CWH') || val.serial_id.startsWith('MN-PWH'));
            break;
          case 'ajtnk-gc':
            devices = result.data.filter((val) => val.serial_id.startsWith('SP2-GA'));
            break;
          case 'ajtnk-tftc':
            devices = result.data.filter((val) => val.serial_id.startsWith('SP2-TFTC'));
            break;
          default:
            devices = result.data
            break;
        }
      }
      else {
        devices = result.data
      }
      devices.forEach((element) => {
        this.idList.push({
          name: element.name,
          serial_id: element.serial_id,
          id: element.id,
        });
        // // // console.log(element)
        if (element.lora)
          this.sensorlist.push({
            name: element.name,
            serial_id: element.serial_id,
            type: element.type,
            network: element.network,
            location: element.islocated || "Unavailable",
            active: element.active,
            signal: element.rssi ? element.rssi : "100",
            bat: element.battery ? element.battery : "100",
            lora: element.lora,
          });
        else
          this.sensorlist.push({
            name: element.name,
            serial_id: element.serial_id,
            gatewayid: element.gatewayid,
            type: element.type,
            network: element.network,
            location: element.islocated || "Unavailable",
            active: element.active,
            signal: element.rssi ? element.rssi : "100",
            bat: element.battery ? element.battery : "100",
            lora: element.lora,
          });
      });
      // // console.log(this.sensorlist)
      this.primeTable = this.sensorlist;

      this.sensorlist.forEach((element) => {
        this.filterType.push(element.type);
        this.filterNetwork.push(element.network);
        this.filterLocation.push(element.location);
        this.filterSerialNumber.push(element.serial_id);
        // this.filterActive.push(element.active);
      });

      // console.log(this.filterType);
      this.filterType = new Set(this.filterType);
      this.filterNetwork = new Set(this.filterNetwork);
      this.filterLocation = new Set(this.filterLocation);
      this.filterSerialNumber = new Set(this.filterSerialNumber);
      // this.filterActive = new Set(this.filterActive);
    });
  },
  computed: {
    filteredList() {
      console.log("this.selectFilterActive", this.selectFilterActive);
      return this.sensorlist.filter((post) => {
        // console.log(post.active);
        return (
          post.name
            .toString()
            .toLowerCase()
            .includes(this.selectFilterName.toLowerCase()) &&
          post.type
            .toString()
            .toLowerCase()
            .includes(this.selectFilterType.toLowerCase()) &&
          post.serial_id
            .toString()
            .toLowerCase()
            .includes(this.selectFilterSerialNumber.toLowerCase()) &&
          post.network
            .toString()
            .toLowerCase()
            .includes(this.selectFilterNetwork.toLowerCase()) &&
          this.filterByStatus(post, this.selectFilterActive)
        );
      });
    },
  },
};
</script>
<style scoped>
.roundedCard {
  border-radius: 20px;
}

#btns {
  cursor: pointer;
}

#center {
  display: flex;
  align-items: center;
}

.w3-disabled *,
:disabled * {
  color: black;
}

button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}

th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}

#v {
  display: none;
}

#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}

@media screen and (max-width: 600px) {
  #v {
    display: inline;
    padding: 0px;
    right: -20px;
  }

  #p {
    display: none;
  }

  .a {
    /* background: pink; */
    width: 200px;
  }

  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }

  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>